export default class Helpers {

    //Checks numeric values
    static isNumeric = (n) => {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }

    static isNumericV2 = (value) => {

        const regex = /^\d+$/;
        var result = regex.test(value);
        console.log("***isNumericV2 : " + result + " - value: "+value);
        return result;
    }
};